export const formatOption = (_) => _?.text || _?.key || '';
//# sourceMappingURL=formatOption.js.map